// API client for the access-control admin console (PLEX-4095).
//
// Mirrors broadcastApi.js: resolve the endpoint from config
// (ExternalRESTAPI.<Key>), build an absolute URL against the current origin,
// and drive the shared RequestBuilder (auth + retry). Unlike the v2 workspace
// queries there is no fixture fallback: an admin deciding who gets access must
// see a failure as a failure, never placeholder members.

import { getConfig } from "../lib/configMgr";
import { RequestBuilder, toJSON } from "./request";

const url = (key, params = {}) => {
  let path = getConfig().ExternalRESTAPI[key];
  if (!path) throw new Error(`No endpoint configured for ${key}`);
  for (const [name, value] of Object.entries(params)) {
    path = path.replace(`{${name}}`, encodeURIComponent(value));
  }
  return new URL(path, window.location.origin);
};

const ACCESS = {
  program: { list: "ProgramAccess", member: "ProgramAccessMember", param: "programId" },
  project: { list: "ProjectAccess", member: "ProjectAccessMember", param: "projectId" },
};

/** Every program and project in the cell, with owner and members. */
export const fetchAccessResources = (authData) =>
  new RequestBuilder(url("AdminAccessResources"))
    .withAuthorization(authData)
    .withJSONContentType()
    .fetch()
    .then(toJSON);

/** What one user reaches in the cell, and why. */
export const fetchUserAccess = (authData, email) =>
  new RequestBuilder(url("AdminAccessUser", { email: (email || "").trim().toLowerCase() }))
    .withAuthorization(authData)
    .withJSONContentType()
    .fetch()
    .then(toJSON);

/** Grant `email` access to a program (and so all its projects) or to one project. */
export const grantAccess = (authData, kind, id, email) =>
  new RequestBuilder(url(ACCESS[kind].list, { [ACCESS[kind].param]: id }))
    .withAuthorization(authData)
    .withJSONContentType()
    .asPOST(JSON.stringify({ email: (email || "").trim().toLowerCase() }))
    .fetch()
    .then(toJSON);

/** Revoke `email`'s grant on a program or a project. */
export const revokeAccess = (authData, kind, id, email) =>
  new RequestBuilder(url(ACCESS[kind].member, { [ACCESS[kind].param]: id, memberEmail: email }))
    .withAuthorization(authData)
    .asDELETE()
    .fetch()
    .then(toJSON);
